import { Route } from 'src/routes/Route'
import { CatalogSubroute } from 'src/catalog/routes/CatalogRoute'

export const AddCampaignCardRoute = Route({
  path: '/cards/add',
  init: (subroute?: CatalogSubroute) => ({ subroute }),
  fromPath: () => ({}),
  subroute: CatalogSubroute
})

export type AddCampaignCardRoute = Route<typeof AddCampaignCardRoute>
